"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = require("styled-components");
var _focus = require("./focus");
var _theme = _interopRequireDefault(require("../theme"));
var _typographyHelper = require("../utils/typographyHelper");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var categoryNavigationButtonStyles = (0, _styledComponents.css)(["font-family:", ";color:", ";text-decoration:none;padding:10px 18px;border:1px solid ", ";border-radius:", ";margin-left:", ";font-size:", ";background:white;transition:border-color 0.2s ease-in-out;", " &:hover{border-color:", ";color:", ";}", ";"], _theme["default"].buenosAires, _theme["default"].grey120, _theme["default"].grey40, _theme["default"].radii.borderRadius10, _theme["default"].space10, (0, _typographyHelper.pxToRem)(14), function (_ref) {
  var isActive = _ref.isActive;
  return isActive && (0, _styledComponents.css)(["padding:9px 17px;border:2px solid ", ";background:", ";"], _theme["default"].indigo100, _theme["default"].grey20);
}, _theme["default"].indigo80, _theme["default"].grey120, _focus.focusStyles);
var _default = exports["default"] = categoryNavigationButtonStyles;